import React from 'react'

function BalancingProfitBg() {
  return (
    <div className="balancing-profit-bg">
      <div className='bpbg-content'>
        <h2>Balancing profit with purpose <br/> spread trading reinvented.</h2>
        <ul className="author">
          <li>Charles Glah</li>
          <li>Founder, Divergence Capital</li>
        </ul>
      </div>
    </div>
  )
}

export default BalancingProfitBg;